import { createApp, Vue } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { setupAntd } from "@/antd-vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import VueSocialSharing from 'vue-social-sharing'
import { createMetaManager } from 'vue-meta'

const app = createApp(App);
setupAntd(app);

app.use(VueSocialSharing).use(store).use(router).use(createMetaManager()).mount("#app");
